/* eslint-disable @typescript-eslint/no-unused-vars */
// TODO: Fix unused variable

import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  FilterOptionSelectedValue,
  FilterSelectedValue,
} from '../../../hooks/filters/interfaces/filter-selected-value.interface';
import { Filter } from '../../../hooks/filters/interfaces/filter.interface';
import { FilterOptionGroupSelectedValue } from '../multiple-selection.component';

const createOptionGroupSelectedValues = (
  options: FilterOptionSelectedValue[],
) => {
  const dict: Record<string, FilterOptionGroupSelectedValue> = {};
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    const key = option.metadata?.descriptors?.[0];
    if (key) {
      if (dict[key] !== undefined) {
        dict[key].options.push(option);
      } else {
        dict[key] = { value: key, label: key, options: [option] };
      }
    } else {
      dict[option.value] = {
        value: option.value,
        label: option.label,
        options: [option],
      };
    }
  }
  return Object.entries(dict).map(([key, value]) => value);
};
export const useMultipleSelection = (
  filter: Filter,
  options: FilterOptionSelectedValue[],
  changeValueCallback: (selectedValue: FilterSelectedValue) => void,
  selectedValue?: FilterSelectedValue,
) => {
  const [selections, setSelections] = useState<FilterOptionSelectedValue[]>([]);
  const [isInvalid, setIsInvalid] = useState(false);

  const optionsGroup = useMemo(() => {
    return createOptionGroupSelectedValues(options);
  }, [options]);

  const isChecked = useCallback(
    (optionValue: FilterOptionSelectedValue) => {
      return (
        selections?.find((i) => i.value === optionValue.value) !== undefined
      );
    },
    [selections],
  );

  const isGroupChecked = useCallback(
    (selectedOptionsGroupValue: FilterOptionGroupSelectedValue) => {
      for (let i = 0; i < selectedOptionsGroupValue.options.length; i++) {
        const option = selectedOptionsGroupValue.options[i];
        const found = selections.find((o) => o.value === option.value);
        if (!found) {
          return false;
        }
      }
      return true;
    },
    [selections],
  );

  const getGroupCheckedCounter = useCallback(
    (selectedOptionsGroupValue: FilterOptionGroupSelectedValue) => {
      let counter = 0;
      for (let i = 0; i < selectedOptionsGroupValue.options.length; i++) {
        const option = selectedOptionsGroupValue.options[i];
        const found = selections.find((o) => o.value === option.value);
        if (found) {
          counter++;
        }
      }
      return counter;
    },
    [selections],
  );

  const changeHandler = useCallback(
    (checked: boolean, selectedOptionValue: FilterOptionSelectedValue) => {
      //const { checked } = e.currentTarget
      const cleanSelection = selections.filter(
        (i) => i.value !== selectedOptionValue.value,
      );
      const selected = checked
        ? [...cleanSelection, selectedOptionValue]
        : cleanSelection;
      const invalid = filter.required && selected.length === 0;
      setIsInvalid(invalid);
      if (!selectedValue) return;
      if (!invalid)
        changeValueCallback({
          ...selectedValue,
          values: selected.map((i) => ({ value: i.value, label: i.label })),
        });
      setSelections(selected);
    },
    [changeValueCallback, selectedValue, selections, filter],
  );

  const changeGroupHandler = useCallback(
    (
      checked: boolean,
      selectedOptionsGroupValue: FilterOptionGroupSelectedValue,
    ) => {
      //const { checked } = e.currentTarget
      const cleanSelection = selections.filter(
        (i) =>
          !selectedOptionsGroupValue.options.find((o) => o.value === i.value),
      );
      const selected = checked
        ? cleanSelection.concat(selectedOptionsGroupValue.options)
        : cleanSelection;
      const invalid = filter.required && selected.length === 0;
      setIsInvalid(invalid);
      if (!selectedValue) return;
      if (!invalid)
        changeValueCallback({
          ...selectedValue,
          values: selected.map((i) => ({ value: i.value, label: i.label })),
        });
      setSelections(selected);
    },
    [changeValueCallback, selectedValue, selections, filter],
  );

  const isAllChecked = useCallback(() => {
    return selections.length === 0;
  }, [selections]);

  const changeHandlerAll = useCallback(() => {
    if (!selectedValue) return;
    changeValueCallback({ ...selectedValue, values: [] });
    setSelections([]);
  }, [changeValueCallback, selectedValue]);

  useEffect(() => {
    if (selectedValue === undefined) return;
    const selected = selectedValue?.values.map((i) => ({ ...i }));
    setSelections(selected);
  }, [selectedValue]);

  const selectionsWithoutOptions = useMemo(() => {
    return selections.filter(
      (i) => options.find((j) => j.value === i.value) === undefined,
    );
  }, [selections, options]);

  const selectionsWithoutOptionsGroup = useMemo(() => {
    return createOptionGroupSelectedValues(selectionsWithoutOptions);
  }, [selectionsWithoutOptions]);
  // useEffect(()=>{
  //     console.log(selectionsWithoutOptionsGroup)

  // }, [selectionsWithoutOptionsGroup])
  // useEffect(()=>{
  //     console.log(selectionsWithoutOptions)

  // }, [selectionsWithoutOptions])

  const noOptionsClassName = useMemo(() => {
    if (options.length <= 1 && selectionsWithoutOptions.length === 0) {
      return 'no-options';
    } else {
      return '';
    }
  }, [options, selectionsWithoutOptions]);
  return {
    optionsGroup,
    selectionsWithoutOptions,
    selectionsWithoutOptionsGroup,
    noOptionsClassName,
    isInvalid,
    getGroupCheckedCounter,
    isChecked,
    isGroupChecked,
    isAllChecked,
    changeGroupHandler,
    changeHandler,
    changeHandlerAll,
  };
};
